import React from "react";
import { useNavigate } from "react-router-dom";
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';
import SparkasseLogo from '../assets/sparkasse_logo_weiss.png';
import { portal_url } from '../App';
import "./Listen.css";

function Listen() {
  const navigate = useNavigate();

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title blue">Listen</h1>
        <div className="button-container">
        <button className="button_boring_red blue" onClick={() => navigate("/listen/speiseplan")}>
            <span className="material-symbols-outlined">flatware</span>
            Speiseplan
          </button>
        <button className="button_boring_red blue" onClick={() => navigate("/listen/essensreihenfolge")}>
            <span className="material-symbols-outlined">format_list_numbered</span>
            Essensreihenfolge
          </button>
        <button className="button_boring_red blue" onClick={() => navigate("/listen/tagesablauf")}>
            <span className="material-symbols-outlined">schedule</span>
            Tagesablauf
          </button>
        <button className="button_boring_red blue" onClick={() => navigate("/listen/dienstplaene")}> 
            <span className="material-symbols-outlined">assignment</span>
            Im Dienstplan eintragen
          </button>
          <button
            className="button_boring_red blue"
            onClick={() => window.open(`${portal_url}/dienstplaene`, "_blank")}
          >
            <span className="material-symbols-outlined">open_in_new</span>
            Dienstpläne ansehen
          </button>
          <button className="button_boring_red blue" onClick={() => navigate("/listen/finanzamt")}>
            <span className="material-symbols-outlined">account_balance</span>
            Finanzamt
          </button>
          <button className="button_boring_red blue" onClick={() => navigate("/listen/wahlkreis")}>
            <span className="material-symbols-outlined">how_to_vote</span>
            Wahlkreis
          </button>
          <button className="button_boring_red blue" onClick={() => navigate("/listen/sparkasse")}>
            <img src={SparkasseLogo} alt="Sparkasse" className="sparkasse-icon" />
            Sparkasse
          </button>
          <button className="button_boring_red blue" onClick={() => navigate("/listen/selbststaendigkeit")}>
            <span className="material-symbols-outlined">business_center</span>
            Anträge auf Selbstständigkeit
          </button>
          <button className="button_boring_red blue" onClick={() => navigate("/display-steuerung")}>
            <span className="material-symbols-outlined">tv</span>
            Display-Steuerung
          </button>
        </div>
      </div>
    </KernteamLayout>
  );
}

export default Listen;
